export default __webpack_public_path__ + "static/media/Human7.2a006a4c.png";